import React, { useEffect, useState } from 'react';
import { PlanBenefitsItemProps, renderCollapsedView } from './planBenefitsView';
import styles from './style.module.scss';
import ImageWithFallback from '../../globalComponents/image/index';
import DownArrowIcon from '../../../public/images/down-arrow.svg';
import { PlanBenefitsBanner } from './planBenefitsBanner';
import { TierType } from '@/types/tier';

interface PlanBenefitsProps {
  dataSet: PlanBenefitsItemProps[];
  perYearPlan: {
    validity: string;
    pricing: {
      price: number;
    };
  };
  shouldShowToggleButton?: boolean;
  tier: TierType;
  pricePerYear?: boolean;
  status?: string;
}

export const PlanBenefits = (props: PlanBenefitsProps) => {
  const { dataSet, perYearPlan, shouldShowToggleButton = true, tier, pricePerYear, status } = props;

  const [initialWidth, setInitialWidth] = useState(0);
  const [shouldShowExpandedView, setShouldShowExpandedView] = useState<boolean>(false);

  useEffect(() => {
    setInitialWidth(window.innerWidth);
    window.addEventListener('resize', resize);
    resize();
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  const resize = () => {
    if (window.innerWidth >= 768) {
      setShouldShowExpandedView(true);
    }
    if (initialWidth && initialWidth !== window.innerWidth) {
      setShouldShowExpandedView(window.innerWidth >= 768);
    }
  };

  const onToggleButtonClick = () => {
    setShouldShowExpandedView((prevState) => !prevState);
  };

  const renderBenefits = () => {
    if (!dataSet || dataSet.length === 0) {
      return null;
      // return (
      //   <div className="flex flex-col text-center" data-testid="errorMessage">
      //     <p>Something went wrong. Try again later</p>
      //   </div>
      // );
    }

    return (
      <div data-testid="cartTierBenefitsDataSet" className="flex flex-col">
        <div className="flex">
          {renderCollapsedView(dataSet, shouldShowExpandedView || !shouldShowToggleButton, tier)}
        </div>
        {shouldShowToggleButton && (
          <button
            className={`flex gap-s1 self-end pr-4 pb-5 items-center font-bold md:hidden text-[0.875rem] text-[#4E9BFF] leading-[1.3125rem] ${
              !shouldShowExpandedView ? 'md:pt-0 pt-3' : 'md:pt-0 pt-1'
            }`}
            data-testid="collapsibleButton"
            onClick={onToggleButtonClick}
          >
            {!shouldShowExpandedView ? 'View More' : 'View Less'}
            <ImageWithFallback
              src={DownArrowIcon}
              alt={shouldShowExpandedView === false ? 'Collapse Icon' : 'Expand Icon'}
              height={5}
              width={9}
              data-open={shouldShowExpandedView}
              className={`flex w-6 h-6 justify-center ${styles.arrow}`}
              data-testid="downArrowIcon"
            />
          </button>
        )}
      </div>
    );
  };

  if ((!dataSet || dataSet.length === 0) && parseInt(perYearPlan.validity) !== 12) return null;

  return (
    <div className={`${styles.planBenefitsCard} ${styles[tier]}`} data-testid="planBenefit">
      <PlanBenefitsBanner
        tier={tier}
        perYearPlan={perYearPlan}
        pricePerYear={pricePerYear}
        status={status}
      ></PlanBenefitsBanner>
      {renderBenefits()}
    </div>
  );
};
